import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';


const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
  color:#2B3497
`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1;
`;

const TileContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 20px;
  min-height: 59px;
  max-height: 690px;
  overflow-y: auto;
  padding-right: 10px;
  padding-left: 10px;


  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #293495;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
`;

const Tile = styled.div`
  background: rgb(24, 62, 159);
  color: #ffffff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  transition: background 0.3s ease-in-out, color 0.3s ease-in-out, transform 0.3s ease-in-out;
  min-width: 200px;
  min-height: 59px;

  &:hover {
    background: #162D5D;
    color: #ffffff;
    transform: scale(1.05);
  }
`;

// const visitorTypes = [
//     { id: 1, visitorTypeDesc: "Visitor" },
//     { id: 2, visitorTypeDesc: "Contractor" },
//     { id: 3, visitorTypeDesc: "Consultant" },
//     { id: 4, visitorTypeDesc: "Interview" },
//     { id: 5, visitorTypeDesc: "VIP" },
//     { id: 6, visitorTypeDesc: "Customer" },
//     { id: 7, visitorTypeDesc: "Government Official" },
//     { id: 8, visitorTypeDesc: "Interns" },
//     { id: 9, visitorTypeDesc: "Service Engineer" },
//     { id: 10, visitorTypeDesc: "External Visitor" },
//     { id: 11, visitorTypeDesc: "External Interns" },
//     { id: 12, visitorTypeDesc: "Food Vendor" },
//     { id: 13, visitorTypeDesc: "Food Officer" },
// ];

const VisitorTypeSelectionPage = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook
  const [searchTerm, setSearchTerm] = useState('');

  const [empId, setEmpId] = useState('');
  const [visitorTypes, setVisitorTypes] = useState('');

  useEffect(() => {
    // Set empId from localStorage when component mounts
    const storedEmpId = localStorage.getItem("employeeId");
    if (storedEmpId) {
      setEmpId(storedEmpId);
    }
  }, []);

  useEffect(() => {
    const fetchVisitorTypeDetails = async () => {
      if (empId) {
        try {
          const responseEMP = await axios.get(`/VisitorType/GetVisitorTypeDetailsByEmpId/${empId}`);
          setVisitorTypes(responseEMP.data);
        } catch (error) {
          console.error('Error fetching appointment data:', error);
        }
      }
    };

    fetchVisitorTypeDetails();
  }, [empId]);

  if (empId) {

  }

  const filteredVisitorTypes = Array.isArray(visitorTypes)
    ? visitorTypes.filter((visitor) =>
      visitor.visitorTypeDesc.toLowerCase().includes(searchTerm.toLowerCase())
    )
    : [];

  const handleTileClick = (visitorTypeDetails) => {
    console.log("Selected Visitor Type:", visitorTypeDetails);

    if (
      visitorTypeDetails.individualAppointmentInputField &&
      visitorTypeDetails.individualAppointmentInputField.length > 0
    ) {
      console.log("Selected Visitor Type:", visitorTypeDetails.individualAppointmentInputField);
      navigate('/layout/individual-appointment', { state: { visitorTypeDetails } });
    } else {
      toast.error("This visitor type does not have any input field requirements.");
      // Optionally, show a message or toast to the user
    }
  };

  return (
    <Container>
      <Header>
        <Heading>Individual Appointment - Visitor Type Selection</Heading>
        <SearchBox>
          <SearchInput
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </SearchBox>
      </Header>
      <TileContainer>
        {filteredVisitorTypes.filter(visitor => !visitor.isDeleted).length > 0 ? (
          filteredVisitorTypes
            .filter(visitor => !visitor.isDeleted)
            .map((visitor) => (
              <Tile key={visitor.id} onClick={() => handleTileClick(visitor)}>
                {visitor.visitorTypeDesc}
              </Tile>
            ))
        ) : (
          <Tile>No results found</Tile>
        )}
      </TileContainer>
      <ToastContainer />

    </Container>
  );
};

export default VisitorTypeSelectionPage;
